import { useCallback, useEffect, useState } from 'react';
import { galleryItems } from '../data.js';
import { ArrowLeftIcon, ArrowRightIcon } from './Icons.jsx';

export function Gallery() {
  const [current, setCurrent] = useState(0);

  const showPrevious = useCallback(() => {
    setCurrent((index) => (index - 1 + galleryItems.length) % galleryItems.length);
  }, []);

  const showNext = useCallback(() => {
    setCurrent((index) => (index + 1) % galleryItems.length);
  }, []);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'ArrowLeft') showPrevious();
      if (event.key === 'ArrowRight') showNext();
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [showNext, showPrevious]);

  const item = galleryItems[current];

  return (
    <section className="gallery" aria-roledescription="carousel" aria-label="Production photographs">
      <div className="gallery-frame">
        <img src={item.image} alt={item.caption} />
        <div className="gallery-shade" />
        <div className="gallery-caption" aria-live="polite">
          <span>{String(current + 1).padStart(2, '0')} / {galleryItems.length}</span>
          <h2>{item.title}</h2>
          <p>{item.caption}</p>
        </div>
        <div className="gallery-controls">
          <button type="button" onClick={showPrevious} aria-label="Previous photograph">
            <ArrowLeftIcon />
          </button>
          <button type="button" onClick={showNext} aria-label="Next photograph">
            <ArrowRightIcon />
          </button>
        </div>
      </div>
      <div className="gallery-thumbnails" aria-label="Choose a photograph">
        {galleryItems.map((galleryItem, index) => (
          <button
            type="button"
            key={galleryItem.image}
            className={index === current ? 'is-current' : ''}
            aria-label={`Show photograph ${index + 1}: ${galleryItem.title}`}
            aria-current={index === current ? 'true' : undefined}
            onClick={() => setCurrent(index)}
          >
            <img src={galleryItem.image} alt="" loading="lazy" />
          </button>
        ))}
      </div>
      <p className="photo-credit">
        Photos by Todd Gardiner /{' '}
        <a href="https://www.hieroglyphphotography.com/" target="_blank" rel="noreferrer">
          Hieroglyph Photography
        </a>
      </p>
    </section>
  );
}
